import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCircleCheckmarkIconSecondary from './svgs/CircleCheckmarkIconSecondary.js';
import SvgCircleCheckmarkIcon from './svgs/CircleCheckmarkIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var circleCheckmarkIcon = (props => useIcon(SvgCircleCheckmarkIcon, SvgCircleCheckmarkIconSecondary, props));

export { circleCheckmarkIcon as default };
